import { action } from '../../../appLogic/appActions';

export const SEND_MESSAGE = action('SEND_MESSAGE');
